// @flow

export const spacingSizes = [
  "0px",
  "5px",
  "10px",
  "15px",
  "20px",
  "30px",
  "40px",
  "50px",
  "60px"
];

const spacings = {
  padding: "padding",
  paddingV: size =>
    `
    padding-top: ${size};
    padding-bottom: ${size};
  `,
  paddingH: size =>
    `
    padding-left: ${size};
    padding-right: ${size};
  `,
  paddingL: "padding-left",
  paddingT: "padding-top",
  paddingR: "padding-right",
  paddingB: "padding-bottom",
  margin: "margin",
  marginV: size =>
    `
    margin-top: ${size};
    margin-bottom: ${size};
  `,
  marginH: size =>
    `
    margin-left: ${size};
    margin-right: ${size};
  `,
  marginL: "margin-left",
  marginT: "margin-top",
  marginR: "margin-right",
  marginB: "margin-bottom"
};

const spacingExtender = props => {
  let styles = "";

  Object.keys(spacings).forEach(spacing => {
    const size = spacingSizes[props[spacing]];

    if (size) {
      // Check that a valid spacing size is passed in.
      if (typeof spacings[spacing] === "function") {
        styles += spacings[spacing](size);
      } else if (typeof spacings[spacing] === "string") {
        styles += `${spacings[spacing]}: ${size};`;
      }
    }
  });

  return styles;
};
export default spacingExtender;

export const disabledSpacingExtender = props =>
  (props.enableCustomSpacing ? spacingExtender(props) : "");



// WEBPACK FOOTER //
// ./src/common/spacingExtender.js